<template>
	<div>
		Nav
	</div>
</template>

<script>
	export default {
		name: 'navigation-view'
	}
</script>

<style lang="scss" scoped>

</style>